module.exports = __webpack_public_path__ + "assets/images/logo-facebook.png?8c576d87b80a3c083c4c8b19b73890aa";


//////////////////
// WEBPACK FOOTER
// ./_source/images/logo/logo-facebook.png
// module id = 603
// module chunks = 0